import { atom } from "jotai";
import { Canvas } from "../types";
import { isStreamingZslAtom } from "../../../streaming/src/atoms/streamingStatusAtoms";
import { nodesAtom } from "../nodes";
import { deriveZslFromCanvasAtom } from "../utils";
import { zslAtom } from "../templates";
import { isDraftModeExcludingTemplatesAtom } from "../nodes";

const defaultCanvasState = {
  id: "",
  account_id: 0,
  name: "",
  nodes: [],
  edges: [],
  lastchanged: null,
  created: null,
  description: null,
  customuser_id: null,
  access_level: "can_view" as const,
};

// Create a base atom for the canvas state
const baseCanvasAtom = atom<Canvas>(defaultCanvasState);
baseCanvasAtom.debugLabel = "baseCanvasAtom";

export const canvasAtom = atom<
  Canvas,
  [Canvas | ((prev: Canvas) => Canvas)],
  void
>(
  // Getter
  (get) => get(baseCanvasAtom),
  // Setter
  (get, set, update: Canvas | ((prev: Canvas) => Canvas)) => {
    // Get current canvas state
    const currentCanvas = get(baseCanvasAtom);
    const isStreamingZsl = get(isStreamingZslAtom);
    // Apply the update (handling both direct and functional updates)
    const newCanvas =
      typeof update === "function" ? update(currentCanvas) : update;

    // Update canvas state
    set(baseCanvasAtom, newCanvas);

    // Get current nodes
    const nodes = get(nodesAtom);
    const isDraftModeNotTemplates = get(isDraftModeExcludingTemplatesAtom);

    // for now we don't want to mess with the template flow with the canvas<>zsl integration
    if (isDraftModeNotTemplates && !isStreamingZsl) {
      // Update ZSL state using the utility function
      const currentZsl = get(zslAtom);
      if (currentZsl) {
        const deriveZslFromCanvas = get(deriveZslFromCanvasAtom);
        const updatedZsl = deriveZslFromCanvas(currentZsl, newCanvas, nodes);
        if (updatedZsl) {
          set(zslAtom, updatedZsl);
        }
      }
    }
  },
);
canvasAtom.debugLabel = "canvasAtom";

export const canvasNameAtom = atom((get) => get(canvasAtom).name);
canvasNameAtom.debugLabel = "canvasNameAtom";

export const canvasIdAtom = atom((get) => get(canvasAtom).id);
canvasIdAtom.debugLabel = "canvasIdAtom";

export const canvasDescriptionAtom = atom((get) => get(canvasAtom).description);
canvasDescriptionAtom.debugLabel = "canvasDescriptionAtom";
